import { findParentComponent } from './components';

export const getParentFormId = (componentInstance) => {
  const form = findParentComponent(componentInstance, 'bm-form');
  if (form !== null) {
    return form.id;
  }
  return '';
};

export const getTextInputValue = (value, isNumber) => {
  let formattedValue = value;

  // Prevent some wierd behavior on certain browser on the first call
  if (formattedValue.trimStart) {
    formattedValue = formattedValue.trimStart();
  }

  if (isNumber) {
    formattedValue = value.trimEnd();
    let numberValue = 0;

    if (formattedValue.indexOf('.') >= 0) {
      numberValue = parseFloat(formattedValue);
    } else if (formattedValue.indexOf(',') >= 0) {
      formattedValue = formattedValue.replace(',', '.');
      numberValue = parseFloat(formattedValue);
    } else {
      numberValue = parseInt(formattedValue, 10);
    }

    if (Number.isNaN(numberValue)) {
      return '';
    }

    return numberValue;
  }

  return formattedValue;
};

export const fieldReset = (input) => {
  input.classList.remove('is-invalid');
  input.classList.remove('is-valid');
};

export default {};
